/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { UserInputFilePart } from "./UserInputFilePart";
import type { UserInputFilePartWithUrl } from "./UserInputFilePartWithUrl";
import type { UserInputImagePart } from "./UserInputImagePart";
import type { UserInputImagePartWithUrl } from "./UserInputImagePartWithUrl";
import type { UserInputTextPart } from "./UserInputTextPart";

export type UserInputContentList = (
  | UserInputTextPart
  | UserInputImagePart
  | UserInputImagePartWithUrl
  | UserInputFilePart
  | UserInputFilePartWithUrl
)[];
